import { LogDisplayMode, LogType } from '@infodata-group/inf-commons';
import { CustomLog } from './custom-log';
import { CustomLogDecorator, CustomLogFromDecorator } from './custom-log-from-decorator';

export class CustomLogger {
  public static displayMode = LogDisplayMode.console;
  public static userContext: any;
  public static token: string;
  private static logStack: CustomLog[] = [];

  public static v(o: unknown) {
    if (o instanceof CustomLogDecorator) {
      const log = new CustomLogFromDecorator(o, LogType.verbose);
      this.logStack.push(log);
      this.print(log);
      return;
    }
    const l = new CustomLog(o, LogType.verbose);
    this.logStack.push(l);
    this.print(l);
  }

  public static e(o: unknown) {
    const l = new CustomLog(o, LogType.error);
    this.logStack.push(l);
    this.print(l);
  }

  public static s(o: unknown) {
    const l = new CustomLog(o, LogType.special);
    this.logStack.push(l);
    this.print(l);
  }

  public static w(o: unknown) {
    const l = new CustomLog(o, LogType.warning);
    this.logStack.push(l);
    this.print(l);
  }

  public static printStack() {
    console.log({
      header: this.generateHeader(),
      logs: this.logStack,
    });
    // this.logStack = [];
  }

  public static print(l: CustomLog) {
    switch (this.displayMode) {
      case LogDisplayMode.console:
        l.console();
        if (this.logStack.length % 100 === 0) {
          this.printStack();
        }
        break;
      case LogDisplayMode.debug:
        if (l.type === LogType.error || this.logStack.length > 20) {
          this.printStack();
        }
        break;
      case LogDisplayMode.soft:
        if (l.type === LogType.error) {
          this.printStack();
        }
    }
  }

  private static generateHeader() {
    return {
      token: this.token,
      user: this.userContext,
      userAgent: navigator.userAgent,
      href: window.location.toString(),
    };
  }
}
